import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { RECIPIENTS_FEATURE_KEY } from './recipients-collection.state';
import { RecipientsEffects } from './effects/recipients.effects';
import { recipientsReducer } from './reducers/recipients.reducer';
import { selectRecipientsEntries } from './selectors/recipients.selector';

/**
 * Registers the recipients store slice. Import once where the recipients feature is
 * bootstrapped (`apps/pace` `AppModule`, next to `UserMasterStoreModule`) — the module is
 * eagerly loaded there, so the slice and its load effect exist before
 * `RecipientsNgrxService.init()` dispatches `initRecipients`.
 *
 * The slice registers its projection selector with the generic persistence layer, which
 * persists the collection to the concurrency store under the default `recipientsSlice` key.
 * This is a **different backend** from the legacy `LocalStorageRecipientsService` (encrypted
 * file storage under the `RECIPIENTS` key): with the NgRx path active the two no longer
 * share storage, so saved recipients do not carry across an `enableNgRx` flag flip.
 * A cross-backend data migration is deferred until the overall NgRx migration is complete.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(RECIPIENTS_FEATURE_KEY, recipientsReducer),
        EffectsModule.forFeature([RecipientsEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: RECIPIENTS_FEATURE_KEY,
                persistSelector: selectRecipientsEntries,
            },
        },
    ],
})
export class RecipientsStoreModule {}
